import { PodInstallFunction } from "@web-monorepo/shared/podInfra";
import sortBy from "lodash/sortBy";
import { Tool } from "./components/EditableSetup";
import createResourceClient from "src/utils/setupAll";

export type ToolkitDataSlice = { toolkitData: { tools: Record<string, Record<string, Tool>> } };

export function selectTool(type: string, classId: string, state: ToolkitDataSlice) {
  const tools = state?.toolkitData?.tools?.[classId];
  if (!tools) return;

  return sortBy(
    Object.values(tools).filter((tool) => tool.type === type),
    "updatedAt",
  ).reverse();
}

const makeUpdatePath = ({ classId }: { classId: string }) => ["tools", classId];
const makePath = ({ classId }: { classId: string }) => `/api/dojoClass/${classId}/tool`;
const makeBody = ({ payload, type, dojoId, _id }: Tool) => ({ payload, type, dojoId, _id });

const {
  collectionGetActionCreator: fetchTools,
  collectionPostActionCreator: createTool,
  memberPutActionCreator: editTool,
  memberDeleteActionCreator: deleteTool,
  installReducers,
  installSagas,
} = createResourceClient({ stateKey: "toolkitData", makeUpdatePath, makePath, makeBody });

export { fetchTools, editTool, createTool, deleteTool };

const install: PodInstallFunction = (installReducer, installSaga) => {
  installReducers(installReducer, { tools: {} });
  installSagas(installSaga);
};

export default install;
